<template>
  <div>
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <v-container>
     <v-card>
      <v-card-title>
       <span class="headline">View Document List</span>
       <v-spacer></v-spacer>
     </v-card-title>
     <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs12 sm6 md4>
              <v-autocomplete            
              label="Module Name"
              item-text="menu_name"
              item-value="id"
              v-model="formSchema.menu_id"            
              :items="subMenuList" 
              clearable
              single-line hide-details         
              ></v-autocomplete>
            </v-flex>
            
            <v-flex xs12 sm6 md4>
              <v-text-field
              label="Document Name"
              v-model="formSchema.document_title"
              ></v-text-field>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>
      <v-flex xs12 sm6 md4></v-flex>
      <v-flex xs12 sm6 md9>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="error" @click.native="reset">Reset</v-btn> -->
          <v-btn color="success" @click.native="validateBeforeSubmit">
            <v-icon>search</v-icon> Search</v-btn>
        </v-card-actions>
      </v-flex>

    </v-form>
    <v-data-table
    :headers="headers"
    :items="items"    
    >
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">{{ ++(props.index) }}</td>
      <td class="text-xs-left">{{ props.item.document_name }}</td>
      <td class="text-xs-center">
        <div class="displayInline">
          <a :href="`${public_path}${props.item.document_file_name}`" target="_blank" rel="noopener noreferrer" download="">
            <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>                
          </a>
        </div>
        <div v-if="props.item.document_file_name_02" class="displayInline">
          <a :href="`${public_path}${props.item.document_file_name_02}`" target="_blank" rel="noopener noreferrer" download="">
            <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>                
          </a>
        </div>
        <div v-if="props.item.document_file_name_03" class="displayInline">
          <a :href="`${public_path}${props.item.document_file_name_03}`" target="_blank" rel="noopener noreferrer" download="">
            <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>                
          </a>
        </div>

      </td>

    </template> 

    <template slot="no-data" class="error">
      <div align="center">No Data Found</div>
    </template>
  </v-data-table>
  <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!--> 
  </v-card>
</v-container>

</div>
</template>
<script>
const commonService = require('../../services/common.service');

import {preFix} from '../../vuex/api'
import ServerPath from "../../server-path/server-path";
import Axios from 'axios'
export default {
  data: () => ({
    showForm : false,
    valid: true,
    dialog: false,
    dialogEditForm:false,
    publicPath:'',
    formSchema:{

      menu_id:'',
      document_title:'',

    },

    search: '',
    totalItems: 0,      
    loading: true,

    pagination: {
      sortBy: 'id',
      descending:true,
    },

    selected:[],
    search:'',      
    headers: [
    {
     text: 'Sl#',
     align: 'left',
     sortable: false,
     value: 'id'
   },
   {
     text: 'Document Title',			
     sortable: false,
     value: 'document_title'
   },

   {
    text: 'Download',     
    sortable: false,
    align: "center",
    value: ''
  },
  ],
  items: [],
  subMenuList:[],
  item: {           
    edit: false,               
    head_id:'',
    related_account:'',
    name:'',
  },
  delete_id:'',
  row_index:'',
  dialog2: false,
  snackbar: false,
  color: 'success',
  mode: '',
  timeout: 3000,
  left:'left',
  message: '',
  confirmModel: false,
  select: null,
  adminTypelist:[
  {id:1, name:'DIA'},
  {id:3, name:'Institute'},
  ],

  SnackbarVal: {
    snackbar: false,
    color: "success",
    message: "",
  },
}),

  computed: {
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;               
      this.showForm = role.saveButton
      return role;
    }
  },
  created(){
   this.public_path =
   ServerPath.serverPath;

   let root = this;
   commonService.getAllData("get_submenus").then((res) => {
    root.subMenuList = res.data;
  });
 },

 methods: {

  getAllDocuments(){
   commonService.getAllData('get_all_doc_for_view').then( res => {        
     this.items = res.data
  			// console.log(this.subMenuList)
     });
 },

 changeSort (column) {
  if (this.pagination.sortBy === column) {
    this.pagination.descending = !this.pagination.descending
  } else {
    this.pagination.sortBy = column
    this.pagination.descending = false
  }
},

validateBeforeSubmit(e) {
  let path = ServerPath.serverPath
  let headers = {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('accessToken')
    }
  };

  let formSchema = this.formSchema
  formSchema.menu_id = formSchema.menu_id ? formSchema.menu_id : "";

  Axios.post(path+'/api/get_search_doc',formSchema,headers)
  .then(res => {
    if(res.data.status == 1)
    {
      this.items = res.data.data;
      this.loading = false;
    }
    else
    {
      this.SnackbarVal.color = "error";            
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
      this.loading = false;
    }

  })
  .catch(err => {
   console.log(err)
 })

},
reloadData(){
  this.showForm = this.userRole.saveButton;
  this.getAllDocuments()
  this.message = 'Data reloaded successfully!'
  this.snackbar = true
  this.formSchema = {
   id:'',
   record_id:'',
   sub_menu_id:'',
   document_title:'',
   document:''
 }	
},

editItem (item) {
  this.formSchema = item;
  this.showForm = true
				window.scrollTo({ // scroling to top
          top: 0,
          left: 100,
          behavior: "smooth"
        });
			},
			deleteItem (index,id) {          
				this.row_index = index;
				this.delete_id = id;                
				this.confirmModel = true;
			},

			confirmDelete(row_index,id){                    
				commonService.deleteRow(id, 'document-delete').then(res => {
					if (res.status == 1) {
            this.items.splice(row_index, 1);
            this.getAllDocuments();
          } else {
            this.SnackbarVal.color = "error";
          }
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

          this.confirmModel = false;
          this.dialog2 = false;
        });       
			},

			

    },

    mounted () {
      this.getAllDocuments();
    },
  }
  </script>


// WEBPACK FOOTER //
// src/components/document_management/view_upload_document.vue